import { mapToCamelCase } from '@consigli/utils';
import { z } from 'zod';
import { languageSchema } from '../core-api/language';
// Exposed so a request that is "a question plus something else" can compose the
// same fields rather than redeclaring them. questionSchema itself ends in a
// transform, which leaves no .extend() to build on.
export const questionShape = {
    question: z.string(),
    language: languageSchema,
};
export const questionSchema = z.object(questionShape).strict().transform(mapToCamelCase);
